import { Switch } from "@mui/material";
import Typography from "./Typography";

type ToggleButtonProps = {
    label: string;
    className?: string;
    onChange?: () => void;
    disabled?: boolean;
};

const ToggleButton = ({
    label,
    className,
    onChange,
    disabled,
}: ToggleButtonProps) => {
    return (
        <div className={className}>
            <Switch onChange={onChange} disabled={disabled} />
            <Typography variant={"label-medium"} component={"label"}>
                {label}
            </Typography>
        </div>
    );
};

export default ToggleButton;
